import React from 'react'
import Success from './views/Success/Success'
import Pending from './views/Pending/Pending'
import Error from './views/Error/Error'

interface Props {
    onClose: () => void
    view: string
}

function Content({ onClose, view }: Props) {
    return (
        <>
            {view === 'pending' && <Pending onClose={onClose} />}
            {view === 'success' && <Success onClose={onClose} />}
            {view === 'error' && <Error onClose={onClose} />}
        </>
    )
}

export default Content
